<script>
    import ModalSkill from '../modal/modalSkill.svelte'

	import { onMount } from 'svelte'
    import { CheckLink, CheckAttribute, GetModalSkillList, CheckMonsterData } from '../../../script/handle/write'

    export let Monster, Section, Skill, SkillData
    //let skillData = []
    let ShowSkillModal = false, SelectPosition = -1
    let ModalSkillList = []

	onMount(async () => {
        //console.log(SkillData);
    })

    // 특성 선택
    function clickAttribute(_i, _j) {
        CheckAttribute(Monster, Section, _i, _j)
    }

    // 마스터 스킬 선택
    function clickMaster() {
        CheckMonsterData()
    }

    function callSkillModal(_position) {
        if(Section == 0 && _position == 0) {
            alert('초기 스킬은 변경이 불가능합니다.')
        } else {
            ShowSkillModal = true
            SelectPosition = _position
            ModalSkillList = GetModalSkillList(Skill, SkillData)
        }
    }

    
</script>

{#await SkillData}
    <div class="issue">Skill Data Lodding...</div>
{:then data} 
    {#if data.length > 0}
        {#each Skill as skill, i}
            <div class='skill'>
                <div class="top" on:click={() => callSkillModal(i)}>
                    {data[(skill.num-1)].name}
                </div>

                <!--<div class="bottom">-->
                    <div class="left" on:click={() => callSkillModal(i)}>
                        <img
                            src="{CheckLink()}/img/monsters/{Monster}/{Section}_{skill.num}.png"
                            alt="{Monster}_{Section}_{skill.num}"
                        >
                    </div>

                    <div class="right">
                        <div class="attribute">
                            <div class="tag">특성</div>

                            {#each data[(skill.num-1)].attribute as attribute, j}
                                <label>
                                    <input
                                        type="checkbox" value={j}
                                        bind:group={skill.attribute}
                                        on:change={() => clickAttribute(i, j)}
                                    />
                                    <p>{attribute.detail}</p>
                                </label>
                            {/each}
                        </div>

                        {#if Section == 0}
                            <hr />

                            <div class="master">
                                <div class="tag">마스터</div>

                                {#each data[(skill.num-1)].master as master, j}
                                    <label>
                                        <input
                                            type="radio" value={j}
                                            bind:group={skill.master}
                                            on:change={() => clickMaster()}
                                        />
                                        <p>
                                            M.{master.name} <br>
                                            {master.detail}
                                        </p>
                                    </label>
                                {/each}
                            </div>
                        {/if}
                    </div>
                <!--</div>-->
            </div>
        {/each}

        {#if Skill.length >= 0 && Skill.length < 3}
            <div class="skill">
                <div class="btn">
                    <svg xmlns="http://www.w3.org/2000/svg" class='top' width="25" height="18" viewBox="0 0 25 18" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M24.2613 4.85226L19.1537 0H-4.88758e-06V4.85226H2.82704e-05V12.3063L4.85229 17.4139L4.85229 4.85226H24.2613Z" fill="#7A67FF"/>
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" class='bottom' width="25" height="18" viewBox="0 0 25 18" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.57764e-05 12.5618L5.10769 17.4141H24.2614V12.5618H24.2613V5.10781L19.4091 0.000162125L19.4091 12.5618H4.57764e-05Z" fill="#7A67FF"/>
                    </svg>

                    <button on:click={() => callSkillModal(-1)}>
                        스킬 추가
                    </button>
                </div>
            </div>
        {/if}
    {/if}
{/await}

{#if ShowSkillModal}
    <ModalSkill
        bind:ShowSkillModal bind:ModalSkillList
        bind:Monster bind:Section bind:Position={SelectPosition} 
    />
{/if}

<style lang="scss">
    .issue {
        font-size: 24px;
        font-family: aggro;
    }

    .skill {
        width: calc(100%);
        height: fit-content;

        .top {
            width: fit-content;
            height: fit-content;
            font-size: 20px;
            font-family: aggro;

            &:hover { cursor: pointer; }
        }

        .left {
            width: 30%;
            display: inline-block;
            vertical-align: top;

            img { width: 100%; }

            &:hover { cursor: pointer; }
        }            

        .right {
            width: calc(70% - 20px);
            height: fit-content;
            padding: 10px;

            display: inline-block;
            vertical-align: top;

            .tag {
                width: fit-content;
                height: fit-content;
                font-size: 14px;
                font-family: aggro;
            }

            .attribute, .master {
                width: 100%;
                height: fit-content;

                label {
                    margin: 4px 0px;
                    font-size: 12px;
                    display: block;
                    cursor: pointer;

                    &:hover:not(input[type=checkbox]:checked) {
                        p {
                            background: $cl6;
                            color: $cl2;
                        }
                    }

                    input[type=checkbox], input[type=radio] {
                        display: none;

                        &:checked + p {
                            background: $cl3;
                            color: $cl2;
                        }
                    }
                    
                    p {
                        width: fit-content;
                        height: fit-content;
                        margin: 0px;
                        padding: 5px 10px;
                        border: 1px solid $cl3;
                        border-radius: $br1;
                    }
                }
            }
        }

        .btn {
            width: calc(100% - 8px);
            height: fit-content;
            margin: 10px 0px;
            padding: 3px 4px;
            position: relative;

            &:hover {
                button {
                    background: $cl3;
                    cursor: pointer;
                }
                svg {
                    fill: $cl3;
                    rect { 
                        fill: $cl3;
                    }
                }
            }

            svg {
                position: absolute;

                &.top {
                    top: 0;
                    left: 0;
                }

                &.bottom {
                    bottom: 0;
                    right: 0 ;
                }
            }

            button {
                background: none;
                width: calc(100%);
                height: 100%;
                padding: 10px 18px;
                padding-bottom: 5px;
                border: 2px solid $cl3;
                color: #FFFFFF;
                font-size: 18px;
                font-family: aggro;
                vertical-align: top;
            }
        }
    }

    hr {
        margin: 10px 0px;
    }
</style>